import React, { Component } from 'react';
import PortalDropdown from '../../../portal/portalDropdown';

const AuthnRequestBindingDropdownContainer = props => 
    <PortalDropdown
        {...props}
        hintText={props.hintText}
        floatingLabelText={props.floatingLabelText}
        width={props.width}
        disabled={props.disabled}
        onChange={props.onChange}
        errorText={props.errorText}
        value={props.value}
        helpTooltipText={props.helpTooltipText}
        items={props.items}
    />;

export default AuthnRequestBindingDropdownContainer;